'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckboxGroup = require('./CheckboxGroup');

Object.defineProperty(exports, 'CheckboxGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CheckboxGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/checkboxGroup/index.js
// module id = 556
// module chunks = 0